import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux'

import "react-responsive-carousel/lib/styles/carousel.min.css";

import CardsGroupsSummary from './cardsGroupsSummary';

class CardsGroupsList extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            topPosition: null,
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.list.classList.add('popup-menu-list-position')
        }, 1);
        setTimeout(() => {
            let listHeight = this.list ? this.list.clientHeight : null
            if (listHeight && listHeight < 440) {
                let topPosition = (listHeight / 2) - 25
                this.list.style.top = `-${topPosition}px`
                this.setState({ topPosition: topPosition })
            }
        }, 675)
    }

    componentDidUpdate() {
        if (this.props.popup !== 'none' || this.props.cardsLoading) {
            this.list.style.opacity = 0
            this.list.style.pointerEvents = 'none'
        } else {
            this.list.style.opacity = 1
            this.list.style.pointerEvents = 'auto'
        }

        if (this.props.popUpMenu.expanded) {
            this.list.style.top = '-35vh'
            this.list.classList.add('popup-list-expanded')
        } else if (this.list.classList.contains('popup-list-expanded')) {
            this.list.classList.remove('popup-list-expanded')
            this.list.style.top = this.state.topPosition ? `-${this.state.topPosition}px` : '-165px'
        }
    }

    render(){
        if (this.props.popUpMenu.closeList) {
            this.list.classList.add('popup-menu-close-list')
        }

        let cardsGroupsRender = []
        for (const categoryId in this.props.cardsGroupsByCategory) {
            cardsGroupsRender.push(
                <CardsGroupsSummary cardsGroupsFeatures={this.props.cardsGroupsByCategory[categoryId]}/>
            )
        }

        const hideLoading = this.props.cardsLoading ? '' : 'hide'
        return (
            <div>
                <div className={'popup-menu-list-layout card-transparent'} ref={ref => this.list = ref}>
                    {cardsGroupsRender}
                </div>
                <div class={`cards-loading-container ${hideLoading}`}>
                    <CircularProgress size={100}/>
                </div>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        popUpMenu    : state.popUpMenu,
        popup        : state.popup,
        cardsLoading : state.switches.cardsLoading
    }
}

export default connect(mapStateToProps)(CardsGroupsList)